import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { deleteSurplusItem } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useDeleteSurplusItem = (): UseMutationResult<void, AxiosError, number> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: async (id) => {
            await deleteSurplusItem({ path: { id } });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.surplusPanelSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.cashFlow(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
        },
    });
};
